import {Component, OnInit} from '@angular/core';
import {ModalController, NavParams} from '@ionic/angular';
import MsgReader from '@kenjiuno/msgreader';
import {UserService} from '../../provider/user/user.service';
import {DateiSystemService} from '../../provider/datei-system/datei-system.service';
import write_blob, {BlobWriteOptions} from 'capacitor-blob-writer';
import {Directory} from '@capacitor/filesystem';
import {FileOpener as FileOpenerCom, FileOpenerOptions} from '@capacitor-community/file-opener';
import {Capacitor} from '@capacitor/core';

@Component({
	selector: 'app-regisafe-msg-viewer',
	templateUrl: './regisafe-msg-viewer.component.html',
	styleUrls: ['./regisafe-msg-viewer.component.scss'],
})
export class RegisafeMsgViewerComponent implements OnInit {

	msgObject: any = null;
	msgContent: any = null;
	msgAttachments: Array<any> = [];
	submitTime: any = null;
	recipientList: any = null;

	constructor(private modalCtrl: ModalController,
				private navParams: NavParams,
				private userService: UserService,
				private dateiService: DateiSystemService) {
	}

	ngOnInit() {
		const msgBuffer = this.navParams.data.buffer;
		this.msgObject = new MsgReader(msgBuffer);
		this.msgContent = this.msgObject.getFileData();
		this.submitTime = this.userService.formatDate(this.msgContent.clientSubmitTime, true, 'DD.MM.YYYY')

		for (const attachment of this.msgContent.attachments) {
			this.msgAttachments.push(attachment);
		}
		this.recipientList = this.createRecipientsList(this.msgContent.recipients).join(', ');
	}

	async closeModal() {
		await this.modalCtrl.dismiss(false);
	}

	createRecipientsList(recipients) {
		const temp = [];
		for (const recipient of recipients) {
			temp.push(recipient.smtpAddress);
		}
		const unique = [...new Set(temp)];
		return unique;
	}

	getAttachment(attachment) {

		const unit8Arr = this.msgObject.getAttachment(attachment);
		const buffer = unit8Arr.content.buffer;
		const attachmentBlob = new Blob([buffer], {type: 'application/octet-stream'});
		const fileExt = attachment.fileName.split('.').pop();
		const mimeType = this.userService.mimeTypes[fileExt];

		if (Capacitor.getPlatform() === 'ios' || Capacitor.getPlatform() === 'android') {

			const options: BlobWriteOptions = {
				path: attachment.fileName,
				directory: Directory.Cache,
				blob: attachmentBlob,
				recursive: true
			};

			write_blob(options)
				.then((data) => {

					const comOptions: FileOpenerOptions = {
						filePath: data,
						contentType: mimeType,
						openWithDefault: true
					};
					FileOpenerCom.open(comOptions)
						.then(() => {
							console.log('### FileOpenerCom: ');
						})
						.catch((e) => {
							console.log('### FileOpenerCom error: ', e);
						});

				})
				.catch((error) => {
					console.log('getAttachment error: ', error);
				});

		} else {
			// Browser
			const url = window.URL.createObjectURL(new Blob([buffer], {type: mimeType}));
			window.open(url,'_blank');

		}
	}


}
